import { memo } from 'react'
import type { NodeProps } from 'reactflow'
import { TEAM_COLORS } from '../../../../lib/agentColors'

export interface SubgraphNodeData {
  label: string
  team: string
}

export const SubgraphNode = memo(({ data }: NodeProps<SubgraphNodeData>) => {
  const color = TEAM_COLORS[data.team as keyof typeof TEAM_COLORS] ?? '#6B7280'

  return (
    <div
      className="rounded-2xl border-2 w-full h-full"
      style={{
        borderColor: `${color}40`,
        backgroundColor: `${color}08`,
      }}
    >
      <div
        className="px-3 py-1.5 rounded-t-xl"
        style={{ backgroundColor: `${color}18` }}
      >
        <span className="text-xs font-semibold uppercase tracking-wider" style={{ color }}>
          {data.label}
        </span>
      </div>
    </div>
  )
})

SubgraphNode.displayName = 'SubgraphNode'
